module.exports = __webpack_public_path__ + "images/homea94b96bb66657d2ad0f40dd1f698e452.png";